import React from 'react';
import PropTypes from 'prop-types';
import { createAlert } from '@src/actions/BotActions';
import Text from 'relements/build/esm/input/text';

import BotBuilderContants from '@src/phrases';

import styles from './BudgetEntityConfig.scss';

const KEYWORDS = BotBuilderContants.getPhrase;

export default class BudgetEntityConfig extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.left}>
          <Text
            disabled={this.props.disabled}
            label="Minimum number of Digits"
            placeholder="Minimum number of digits that should be detected by this entity"
            value={this.props.metaData.minNumberDigits}
            onChange={this._onMinNumberChange}
            inputType="number"
            min={1}
          />
          <Text
            disabled={this.props.disabled}
            label="Maximum number of Digits"
            placeholder="Maximum number of digits that should be detected by this entity"
            value={this.props.metaData.maxNumberDigits}
            onChange={this._onMaxNumberChange}
            inputType="number"
            min={1}
          />
        </div>
        <div className={styles.right}>
          <div className={styles.header}>How to use this entity?</div>
          <div className={styles.row}>
            This entity can detect numbers from the combination of text &
            number.
          </div>
          <div className={styles.row}>For Example,</div>
          <div className={styles.row}>If the user says: 7 Lakhs</div>
          <div className={styles.row}>It will be detected as 700000</div>
          <div className={styles.row}>
            In the above example, you have to specify the minumum no. of digits
            as 1 since the entity will process based on the numeric values only
            (‘7’ for this example)
          </div>

          <div className={styles.row}>
            So, if the {KEYWORDS('USER_MESSAGE.PLURAL.LOWERCASE')} is seven
            lakhs, then it wont be detected, but if the user messages 7lakhs or
            700000 then it will be detected.
          </div>
        </div>
      </div>
    );
  }

  _onMinNumberChange = (value) => {
    const { metaData } = this.props;
    metaData.minNumberDigits = value;
    this.props.onChange(metaData);
  };

  _onMaxNumberChange = (value) => {
    const { metaData } = this.props;
    metaData.maxNumberDigits = value;
    this.props.onChange(metaData);
  };

  validate = () => {
    if (
      this.props.metaData.minNumberDigits === undefined ||
      this.props.metaData.maxNumberDigits === undefined
    ) {
      createAlert('Please specify min/max number of digits');
      return false;
    }

    const min = parseInt(this.props.metaData.minNumberDigits, 10);
    const max = parseInt(this.props.metaData.maxNumberDigits, 10);

    if (min > max) {
      createAlert(
        'Min number of digits cannot be more than Max number of digits'
      );
      return false;
    }
    return true;
  };
}

BudgetEntityConfig.propTypes = {
  metaData: PropTypes.shape({
    minNumberDigits: PropTypes.string,
    maxNumberDigits: PropTypes.string,
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
